import { Pipe, PipeTransform } from '@angular/core';
import { Area } from '../../resources/area/area.interface';
import { ProjectElement } from '../../resources/element/project-element.interface';

/**
 * Only show active items.
 *
 * Works for both single items and an array of items.
 *
 * @note May not be needed once the stores only contain active
 * entities. Until then, `ngFor` and `[dataSource]` can easily
 * be filtered with this pipe.
 */
@Pipe({
  name: 'active'
})
export class ActivePipe implements PipeTransform {

  /**
   * Filters items by `active: true`.
   *
   * Works for both single items and an array of items.
   *
   * @note Make sure the types are not messed up after using
   *  this pipe.
   * @note Make sure the items are not really deleted, and if
   *  so, does it matter? The active items may eventually be
   *  removed from the data anyway.
   *
   * @param item Item or list of items (entities).
   * @returns Item(s) with active status.
   */
  transform<T>(item: T | T[]): T | T[] {
    if (Array.isArray(item)) {
      const list: T[] = [];
      for (const element of item) {
        if (element['active'] === true) {
          list.push(element);
        }
      }
      return list;
    } else {
      return item['active']
        ? item
        : null;
    }
  }
}
